export default "__VITE_ASSET__DRzYkU4p__";